import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
function Style() {
    return (
        <>
      
 
  <FontAwesomeIcon icon="fa-solid fa-palette" className="fa-lg"  />
  

  
      
      </>
    )
  }
  
  export default Style
  